/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const ArrowRight: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="arrow-right" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M736.6666666666666 340L657.3333333333333 422.1666666666667L858.5 623.3333333333334H340V736.6666666666667H858.5L657.3333333333333 937.8333333333331L736.6666666666666 1020L1076.6666666666665 680L736.6666666666666 340z" : "M589.3333333333334 272L525.8666666666667 337.7333333333333L686.8000000000001 498.6666666666666H272V589.3333333333333H686.8000000000001L525.8666666666667 750.2666666666667L589.3333333333334 816L861.3333333333334 544L589.3333333333334 272z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
ArrowRight.displayName = `Blueprint5.Icon.ArrowRight`;
export default ArrowRight;
